import React from "react";
import Tab from "react-bootstrap/Tab";
import Tabs from "react-bootstrap/Tabs";
import styled from "@emotion/styled";
import { Grid } from "@mui/material";
import ConversationsTab from "./ConversationsTab";
import IncomingMessagesTab from "./IncomingMessagesTab";
import OutgoingMessagesTab from "./OutgoingMessagesTab";
import FirstResponseTimeTab from "./FirstResponseTimeTab";
import ResolutionTimeTab from "./ResolutionTimeTab";
import ResolutionCountTab from "./ResolutionCountTab";

const Wrapper = styled.div`
  padding-left: 10px;
  padding-right: 10px;
`;

const TabTables = ({ agentReportdata }) => {
  const [key, setKey] = React.useState("Conversations");
  return (
    <>
      <div className="chatinput-section">
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
        >
          {/* Conversations Tab */}
          <Tab
            eventKey="Conversations"
            title={
              !!agentReportdata && !!agentReportdata.conversation
                ? `Conversations (${agentReportdata.conversation.totalCount})`
                : `Conversations (0)`
            }
            style={{
              backgroundColor: "#fff",
              padding: "5px",
            }}
            className="tabClass"
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <ConversationsTab agentReportdata={agentReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/* Incoming Messages Tab */}
          <Tab
            eventKey="Incoming"
            title={
              !!agentReportdata && !!agentReportdata.inCommingMsg
                ? `Incoming Messages (${agentReportdata.inCommingMsg.totalCount})`
                : `Incoming Messages (0)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <IncomingMessagesTab agentReportdata={agentReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/* Outgoing Messages Tab */}
          <Tab
            eventKey="Outgoing"
            title={
              !!agentReportdata && !!agentReportdata.outGoingMsg
                ? `Outgoing Messages (${agentReportdata.outGoingMsg.totalCount})`
                : `Outgoing Messages ()`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <OutgoingMessagesTab agentReportdata={agentReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/*First response time Messages Tab */}
          <Tab
            eventKey="FirstrResponseTime"
            title={
              !!agentReportdata && !!agentReportdata.firstResponseTime
                ? `First response time (${agentReportdata.firstResponseTime.totalCount})`
                : `First response time (00:00:00)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <FirstResponseTimeTab agentReportdata={agentReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/*Resolution Time Messages Tab */}
          <Tab
            eventKey="ResolutionTime"
            title={
              !!agentReportdata && !!agentReportdata.ResolutionTime
                ? `Resolution Time (${agentReportdata.ResolutionTime.totalCount})`
                : `Resolution Time (00:00:00)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <ResolutionTimeTab agentReportdata={agentReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>

          {/*Resolution Count Messages Tab */}
          <Tab
            eventKey="ResolutionCount"
            title={
              !!agentReportdata && !!agentReportdata.ResolveConversation
                ? `Resolution Count (${agentReportdata.ResolveConversation.totalCount})`
                : `Resolution Count (0)`
            }
            style={{ backgroundColor: "#fff", padding: "5px" }}
          >
            <Wrapper>
              <Grid container spacing={6}>
                <Grid item xs={12} lg={12}>
                  <ResolutionCountTab agentReportdata={agentReportdata} />
                </Grid>
              </Grid>
            </Wrapper>
          </Tab>
        </Tabs>
      </div>
    </>
  );
};

export default TabTables;
